module.exports = __webpack_public_path__ + "static/img/card-contact-phone.58a0091b.png";